import { Box, Text } from '@podiumhq/design-system';
import {
  googleAutocompletePredictionWrapperStyles,
  // GoogleAutocompletePredictionWrapper,
  // GoogleAutocompleteResultsAddress,
  googleAutocompleteResultsAddressStyles,
  // GoogleAutocompleteResultsTitle,
} from './styles';

export const GoogleAutocompletePrediction = ({
  description,
  handlePredictionSelection,
  onKeyDown,
  prediction,
  title,
}) => {
  const onPredictionClick = () =>
    handlePredictionSelection && handlePredictionSelection(prediction);

  return (
    <Box
      onClick={onPredictionClick}
      tabIndex="0"
      onKeyDown={onKeyDown(onPredictionClick)}
      data-e2e="google-prediction"
      {...googleAutocompletePredictionWrapperStyles}
    >
      {title && (
        <Text color="grey.base" fontSize="md" fontWeight="semibold">
          {title}
        </Text>
      )}
      {description && (
        <Text {...googleAutocompleteResultsAddressStyles}>{description}</Text>
      )}
    </Box>
  );
};
